import 'slick-carousel';
import { isAccessDataPoint } from '../../../../../functions/asset.functions';

export default function MapEquipmentDetailController(
  $timeout,
  MaintenanceService,
  $stateParams,
  mapService,
  $uibModal,
  AlertsService,
  usersService,
  equipmentDetailsService,
) {
  'ngInject';
  let vm = this;
  vm.alertsData = [];

  vm.itemDisplayCount = 5; //only show a maximum number of items
  vm.showDate = {}; // change states of show dates globally instead of individualy in ng-repeat
  vm.showDate.faults = false;
  vm.showDate.datapoints = false;
  vm.showDate.alerts = false;
  vm.hasImageFeature = usersService.hasRequiredFeatures(['images']); //Images enabled?
  vm.equipmentDetail = 'yo';
  vm.visibleEquipment = [];

  vm.loading = false;
  vm.errorFlag = false;
  vm.errorText = '';
  vm.showMoreAlerts = false;
  vm.showMoreSeries = false;
  vm.showMoreMaintenance = false;
  vm.loadEquipmentImages = true;

  vm.showMaintenancePopup = showMaintenancePopup;
  vm.makeSparkLines = makeSparkLines;
  vm.openNotesModal = openNotesModal;
  vm.openImageViewModal = openImageViewModal;
  vm.alertAcknowledged = alertAcknowledged;
  vm.acknowledgeAlert = acknowledgeAlert;
  vm.clearAlert = clearAlert;
  vm.refresh = refresh;

  //Make the sparklines for each series
  let colorArray = [
    '#67b7dc',
    '#fdd400',
    '#84b761',
    '#cc4748',
    '#cd82ad',
    '#2f4074',
    '#448e4d',
    '#b7b83f',
    '#b9783f',
    '#b93e3d',
    '#913167',
    '#666',
    '#777',
  ];
  let currColorIndex = 0;

  init();

  function init() {
    return vm.refresh();
  }

  function showMaintenancePopup(plan) {
    MaintenanceService.showPopupForEquipmentPlan(vm.equipmentDetail, plan)
      .result.then(vm.refresh)
      .catch(() => {});
  }

  function deleteImage(imageId, imageIndex) {
    $('#slickequipment').slick('slickRemove', imageIndex);
    equipmentDetailsService.deleteImage(imageId, imageIndex, vm.equipmentDetail);
  }

  function initSlick() {
    $timeout(function () {
      var element = $('#slickequipment');

      if (element.hasClass('slick-initialized')) element.slick('unslick');
      element.slick({
        dots: false,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        prevArrow: '<i class="fa fa-chevron-circle-left fa-lg image-prev"></i>',
        nextArrow: '<i class="fa fa-chevron-circle-right fa-lg image-next"></i>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });

      vm.equipmentDetail.images.forEach((image, index) => {
        element.slick(
          'slickAdd',
          `<div><img class="tr-map-asset-image" style="cursor: pointer" data-index="${index}" src="${image.attributes.href64x64}" /></div>`,
        );
      });

      element.find('img').on('click', function (event) {
        vm.openImageViewModal(parseInt($(this).attr('data-index')));
      });
    }, 50);
  }

  function refresh(loadEqImages) {
    vm.loading = mapService.assetLoading = true;
    vm.errorFlag = false;
    return equipmentDetailsService
      .get($stateParams.equipmentId, [
        'faults',
        'series',
        'alerts',
        'maintenancePlans',
        'attributes',
        'images',
        'users',
      ])
      .then(function (equipmentDetail) {
        vm.visibleEquipment = _.filter(equipmentDetail.series, function (series) {
          return series.display === true && isAccessDataPoint(series.attributes.dataId) === false;
        });
        vm.equipmentDetail = equipmentDetail;
        //Necessary in case where we are clicking and request finishes after started another request, also for updating/refreshing telematics
        setMapData(equipmentDetail);
        vm.loading = mapService.assetLoading = false;
        initSlick();
        return getSparklinesData();
      })
      .catch(function (error) {
        vm.errorFlag = true;
        vm.errorText = error;
      })
      .finally(function () {
        vm.loading = mapService.assetLoading = false;
      });
  }

  function setMapData(equipmentDetails) {
    if (
      !mapService.requestedEquipmentId ||
      mapService.requestedEquipmentId == equipmentDetails.id
    ) {
      let legacyEquipmentModel = equipmentDetails.attributes;
      legacyEquipmentModel.id = equipmentDetails.id;
      mapService.setSelectedEquipment(legacyEquipmentModel);
      mapService.selectedEquipmentFull = equipmentDetails;
    }
  }

  function alertAcknowledged(alert) {
    return alert.attributes.status.toLowerCase() === 'acknowledged';
  }

  function acknowledgeAlert(alert) {
    alert.isDisabled = true;

    return AlertsService.acknowledgeAlert(alert).finally(function () {
      alert.isDisabled = false;
    });
  }

  function clearAlert(alert) {
    alert.isDisabled = true;
    return AlertsService.clearAlert(alert, vm.equipmentDetail.alerts).finally(function () {
      alert.isDisabled = false;
    });
  }

  /*************************** Modals ***************************/

  //ALERT NOTES
  function openNotesModal(alert) {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../../pages/alerts/dashboard/table/list/notes-modal/note.html'),
      controller: 'DashboardNotesModalController',
      size: 'md',
      resolve: {
        alert: function () {
          return alert.attributes;
        },
      },
    });

    // This is needed because angular is complaining that there is no catch for the resulting cancel promise
    // because there is a form in the modal window
    modalInstance.result.catch(function () {});
  }

  function openImageViewModal(pictureIndex) {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../../equipment/components/images-modal/equipment-images.modal.html'),
      controller: 'EquipmentImagesModalController',
      size: 'lg',
      windowClass: 'tr-map-image-modal-dismiss',
      resolve: {
        items: function () {
          return vm.equipmentDetail.images;
        },
        index: pictureIndex,
        users: function () {
          return vm.equipmentDetail.users;
        },
        equipId: function () {
          return vm.equipmentDetail.id;
        },
        profilePictureId: function () {
          if (vm.equipmentDetail.relationships.profileImage) {
            return vm.equipmentDetail.relationships.profileImage.data.id;
          } else {
            return 0;
          }
        },
        onDeleteImageCallback: function () {
          return deleteImage;
        },
      },
    });
  }

  function getSparklinesData() {
    return equipmentDetailsService
      .get($stateParams.equipmentId, ['series', 'series.sparklines'])
      .then(function (equipmentDetail) {
        //update existing series with sparklines data
        vm.visibleEquipment.forEach((series) => {
          const sereiswithSparklines = equipmentDetail.series.find((s) => s.id === series.id);
          if (sereiswithSparklines) {
            series.meta.sparklines = sereiswithSparklines.meta.sparklines;
          }
        });

        //draw chart for the ones already appear on the UI
        vm.visibleEquipment.forEach((series) => {
          makeSparkLines(series);
        });
      })
      .catch(() => {
        console.error(error);
      });
  }

  function makeSparkLines(series) {
    $timeout(function () {
      let dataProvider = _.map(series.meta.sparklines, function (e) {
        return {
          timestamp: new Date(e.t),
          value: e.v,
        };
      });

      let chartColor = colorArray[currColorIndex];

      currColorIndex++;
      currColorIndex %= colorArray.length;

      AmCharts.makeChart('sparkline_' + series.id, {
        type: 'serial',
        theme: 'light',

        dataProvider: dataProvider,
        categoryField: 'timestamp',
        autoMargins: false,
        marginLeft: 0,
        marginRight: 5,
        marginTop: 0,
        marginBottom: 0,
        graphs: [
          {
            valueField: 'value',
            bulletField: 'bullet',
            showBalloon: false,
            lineColor: chartColor,
          },
        ],
        valueAxes: [
          {
            gridAlpha: 0,
            axisAlpha: 0,
          },
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0,
          startOnAxis: true,
        },
      });
    }, 1);
  }
}
